import { render, staticRenderFns } from "./RegisterPage.vue?vue&type=template&id=f97298ba&scoped=true&"
import script from "./RegisterPage.vue?vue&type=script&lang=js&"
export * from "./RegisterPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f97298ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f97298ba')) {
      api.createRecord('f97298ba', component.options)
    } else {
      api.reload('f97298ba', component.options)
    }
    module.hot.accept("./RegisterPage.vue?vue&type=template&id=f97298ba&scoped=true&", function () {
      api.rerender('f97298ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/register/RegisterPage.vue"
export default component.exports